import React from "react";
import {withRouter} from "react-router-dom";
import URL from "../../../../constant/URL";
import Header from "./Header";

const Notice = withRouter((props) => {

  const moveBack = () => {
    props.history.replace({pathname : URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.GUIDE1});
  };

  const moveNext = () => {
    props.history.replace({
      pathname: URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.AI_PREDICTION,
    });
  };

  return (
    <div className="layout-def layout-lc">
      <Header />
    <div className="container">
      <div className="inner">
        <div className="centermiddleBox">
          <div className="centermiddleBox-item">
            <div className="aic-predicBox">
              <h2 className="tit">유의사항</h2>
              <div>
                <ul className="aic-cautionBox">
                  <li className="item1">
                    <span className="num">1</span>
                    <p>
                      테스트는 학습자별로<br/>
                      1회만 가능합니다.
                    </p>
                  </li>
                  <li className="item2">
                    <span className="num">2</span>
                    <p>
                      테스트 도중 그만두거나<br/>
                      끝까지 완료하지 못한 경우<br/>
                      처음부터 다시 시작합니다.
                    </p>
                  </li>
                  <li className="item3">
                    <span className="num">3</span>
                    <p>
                      테스트를 완료한 후에는<br/>
                      재진단이 불가합니다.
                    </p>
                  </li>
                  <li className="item4">
                    <span className="num">4</span>
                    <p>
                      정확한 진단을 위하여<br/>
                      조용한 장소에서 차분하게<br/>
                      진행해 주세요.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="footer">
      <div className="footer-inner">
        <div className="d-flex">
          <div className="d-item">
            <button className="btn-small btn-gray btn-left" onClick={moveBack}><span className="m-txt">이전</span></button>
          </div>
          <div className="d-item btnItem-auto">
            <button className="btn btn-blue" onClick={moveNext}>시작하기</button>
          </div>
        </div>
      </div>
    </div>
    </div>
  );

});

export default Notice;
